module.exports = __webpack_public_path__ + "img/cross-circle.4378cbe6.svg";